module.exports = __webpack_public_path__ + "Yfz3EKkuEAXohMTFW/agent-training-center_navigating_common_challenges.png";